import type { ReactNode } from 'react'

type ShowComparisonTableButtonProps = {
  readonly children: ReactNode
  readonly label: string
}

/**
 * For accessibility reasons, this is controlled with a <details> element,
 * which announces its open/closed state to screen readers.
 * It needs to maintain the <summary> element when opened,
 * but the design requires it to be hidden.
 * So when open, we move it off-screen with absolute positioning,
 * but show it again when focused by keyboard users.
 **/
export function ShowComparisonTableButton({
  children,
  label
}: ShowComparisonTableButtonProps) {
  return (
    <details className="group relative mb-4 lg:mb-12">
      <summary
        className="btn btn-outlined btn-outlined-primary max-w-xs mx-auto select-none cursor-pointer list-none [&::-webkit-details-marker]:hidden group-open:absolute -left-9999 group-open:z-50 group-open:bg-white group-open:hover:bg-complementary-blue-100 group-open:focus-visible:left-0 top-0"
        data-testid="ShowComparisonTableButton"
      >
        <span className="hidden group-open:inline">Hide: </span>
        {label}
      </summary>
      {children}
    </details>
  )
}
